import React, { useState } from 'react'
//Helpers
//@ts-ignore
import logo from './logo.png'
import axios from 'axios'
import ReCAPTCHA from 'react-google-recaptcha'
import image1 from './image1.jpg'
import image2 from './image2.jpg'
import image3 from './image3.jpg'
import Slider from 'react-slick'
import { Link } from 'gatsby'
import { RealEstateDataPageComponentData } from 'types'
import { useCreateFormMutation as useSendContactFormMutationLanding } from '@apis/mediacore/contact'

const settings = {
  autoplay: true,
  dots: false,
  infinite: true,
  speed: 5000,
  items: 3,
  fade: true,
  slidesToShow: 1,
}

const isBrowser = typeof window !== 'undefined'

const LandingPerfo = ({ global_data }: RealEstateDataPageComponentData) => {
  //function current year
  const getCurrentYear = () => {
    const currentYear = new Date().getFullYear()
    return currentYear
  }

  return (
    isBrowser && (
      <section
        className="perfo-landing b"
        id=""
      >
        <div className="d-flex">
          <Slider
            {...settings}
            lazyLoad="ondemand"
            className="overflow-hidden"
          >
            <img
              style={{ height: '100vh' }}
              src={image1}
              alt=""
            />
            <img
              style={{ height: '100vh' }}
              src={image2}
              alt=""
            />
            <img
              style={{ height: '100vh' }}
              src={image3}
              alt=""
            />
          </Slider>
          <div className="container-fluid">
            <div
              className="row align-items-center"
              id="main-section"
            >
              <div className="col-12">
                <div className="row align-items-center justify-content-between">
                  <LandingText />
                  <ContactForm global_data={global_data} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer
          className="mt-3 mt-lg-0 "
          style={{ textAlign: 'center' }}
        >
          <p
            style={{ color: '#fff', fontSize: '16px' }}
            className="copy"
          >
            Promoted by{' '}
            <a
              target="_blank"
              className="text-mediahaus"
              style={{ fontSize: '16px' }}
              href="https://mediahaus.com.ar"
            >
              {' '}
              MediaHaus
            </a>{' '}
            - Powered by{' '}
            <a
              target="_blank"
              className="white"
              href="https://mediacore.app/"
              style={{ color: '#fff', fontSize: '16px' }}
            >
              {' '}
              MediaCore
            </a>
            <br />
            <span className="small-text">Todos los derechos reservados ® {getCurrentYear()}</span>
          </p>
        </footer>
      </section>
    )
  )
}

const LandingText = () => {
  return (
    <div className="col-lg-7">
      <div
        id="flag-section"
        className="d-flex flex-column"
      >
        <h1 className="white">
          Proyecto NAVARRO <br />{' '}
          <div>
            {' '}
            Tu voz, tu futuro <br className="d-block d-lg-none" /> en{' '}
            <div className="text-secondary"> Devoto</div>
          </div>
        </h1>
        <p className="white">
          Descubrí Navarro, el nuevo proyecto de Flamma en Devoto, donde tu elección da forma al
          futuro de tu comunidad. Participa en la definición del diseño de Navarro eligiendo la
          fachada que mejor represente tus visiones y deseos para el barrio.
        </p>
      </div>
      <div className="d-lg-flex justify-content-between">
        <div className="card">
          <img
            src={image1}
            alt=""
          />
          <div>Fachada 1 - Balcón corrido</div>
        </div>
        <div className="card">
          <img
            src={image2}
            alt=""
          />
          <div>Fachada 2 - Corredizo de madera</div>
        </div>
        <div className="card">
          <img
            src={image3}
            alt=""
          />
          <div>Fachada 3 - Ladrillo Beige</div>
        </div>
      </div>
    </div>
  )
}

const ContactForm = ({ global_data }: RealEstateDataPageComponentData) => {
  const [submitted, setSubmitted] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const { captcha, tokko: tokkoKey } = global_data.pageConfig.keys
  // const GAEventsTracker = useGAEventTracker("PPC");

  const [inputValue, setInputValue] = useState({
    nombre: '',
    email: '',
    telefono: '',
    fachada: '',
    comentario: '',
  })

  const handleChange = (event: any) => {
    setInputValue({ ...inputValue, [event.target.name]: event.target.value })
  }

  const [sendContactForm] = useSendContactFormMutationLanding()

  const getUtm = () => {
    if (typeof window !== 'undefined') {
      var queryString = window.location.search
      var urlParams = new URLSearchParams(queryString)
      const tags = []
      for (const [key, value] of urlParams) {
        if (key.includes('source')) {
          tags.push('Origen: ' + value)
        }
        if (key.includes('medium')) {
          tags.push('Pieza: ' + value)
        }
        if (key.includes('campaign')) {
          tags.push('Campaña: ' + value)
        }
      }
      return tags
    }
    return []
  }

  const handleSubmit = (event: any) => {
    let tags = ['Navarro Flamma']
    for (const iterator of getUtm()) {
      tags.push(iterator)
    }

    formTokko(tags, inputValue)
    event.preventDefault()
    setSubmitted(true)
    // GAEventsTracker("Lead",1)
  }

  const formTokko = (
    tags: string[],
    fields: { nombre: string; email: string; fachada: string; telefono: string },
  ) => {
    // Campos del formulario.
    let body = ''
    var name = ''
    //Armo el texto del formulario.
    if (fields.nombre) {
      name += fields.nombre
    }
    if (fields.telefono) {
      body += 'Telefono: ' + fields.telefono + '\n'
    }
    body += 'Email: ' + fields.email + '\n '
    if (fields.fachada) {
      body += 'Fachada: ' + fields.fachada + '\n '
    }

    //Agrego tags.
    var curTags = []
    tags.map((tag) => {
      curTags.push(tag)
    })

    //Armo todo el objeto a enviar
    var message = JSON.stringify({
      name,
      email: fields.email,
      tags,
      text: body,
    })

    sendContactForm({
      data: {
        name: name,
        email: fields.email,
        phone: fields.telefono,
        message: body,
        property_id: '',
      },
      type: 'landing',
      site: global_data.id,
    })

    axios.post('https://tokkobroker.com/api/v1/webcontact/?key=' + tokkoKey + '', message, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  return (
    <div className="col-lg-4 text-center">
      <div className="row justify-content-end">
        <div
          id="response"
          className="col-lg-11"
        ></div>
        <div
          className="col-lg-11 p-4 p-lg-5"
          id="contact-column"
        >
          <div className="form">
            {!submitted ? (
              <>
                <div className="header-wrapper">
                  <h5>
                    Participa en la <br /> elección de la fachada <br /> de Navarro
                  </h5>
                  <img
                    src={logo}
                    className="form-logo"
                    alt="Navarro"
                  />
                </div>
                <form
                  onSubmit={handleSubmit}
                  id="contacto"
                  className="mt-4"
                >
                  <input
                    className="mb-lg-3 mb-3"
                    type="text"
                    onChange={handleChange}
                    name="nombre"
                    placeholder="Nombre completo"
                  />
                  <input
                    className="mb-lg-3 mb-3"
                    type="email"
                    onChange={handleChange}
                    name="email"
                    placeholder="Email *"
                    required
                  />
                  <input
                    className="mb-lg-3 mb-3"
                    type="text"
                    onChange={handleChange}
                    name="telefono"
                    required
                    placeholder="Teléfono Celular *"
                  />
                  <select
                    name="fachada"
                    id="fachada"
                    required
                    className="mb-3"
                    onChange={handleChange}
                  >
                    <option value="">Selección de la Fachada *</option>
                    <option value="1">Fachada 1 - Balcón corrido</option>
                    <option value="2">Fachada 2 - Corredizo de madera</option>
                    <option value="3">Fachada 3 - Ladrillo Beige</option>
                  </select>

                  {/* <!-- <button className="mt-3" type="submit">INVERTÍ AHORA</button> --> */}
                  <div className="d-flex flex-column align-items-center">
                    {/* <ReCAPTCHA
                            sitekey="6Lel-rodAAAAAH3vs9192XBf4sd_bSWNAjtqUX53"
                            onChange={() => setDisabled(false)}
                        /> */}
                    {captcha ? (
                      <ReCAPTCHA
                        sitekey={captcha}
                        onChange={() => setDisabled(false)}
                      />
                    ) : (
                      ''
                    )}
                    <input
                      type="submit"
                      value="ENVIAR MI ELECCIÓN"
                      className="btn mt-4"
                      disabled={disabled}
                      id="submit-info"
                    />
                    {/* disabled={disabled}  */}
                  </div>
                  <p className="text-form">
                    Tu elección es importante para nosotros. Completa el formulario y sé parte de la
                    historia de Navarro en Devoto.
                  </p>
                </form>
              </>
            ) : (
              <>
                {/* {getScript()} */}
                <h5 className="mb-5">
                  ¡Gracias por participar!
                  <br /> Tu elección es muy importante
                  <br /> para nosotros.
                </h5>
                <Link
                  to="/"
                  onClick={() => setSubmitted(false)}
                  className="btn btn-link"
                >
                  VISITAR SITIO WEB FLAMMA
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LandingPerfo
